// extracted by mini-css-extract-plugin
export default {"container":"_05a54d3d232687d5","content":"_9a4bf244bda1ae69"};